import { getPermissions, hasPermission } from "../../utilis/permissionStorage";
import React, { useEffect, useState } from "react";
import Button from "../base/Button";
import BackButton from "../base/BackButton";
import CustomInput from "../base/CustomInput";
import { apiUrl } from "../ApiManager/AxiosHeaders";
import SearchableDropdown from "../base/SearchableDropDown";
import Swal from "sweetalert2";
import CustomSearch from "../base/CustomSearch";
import * as FaIcons from "react-icons/fa";
import { ContentState, convertFromHTML } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import ReactPaginate from "react-paginate";

// Editor Imports
import { EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { convertToHTML } from "draft-convert";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

function AddCheckList() {
  const [permissions, setPermissions] = useState();
  const [checklist, setChecklist] = useState({
    id: "",
    title: "",
    category: null,
    editor: "",
  });
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );
  const [openModal, setOpenModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [skeleton, setSkeleton] = useState(false);
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 10,
    total: 0,
    lastPage: 1,
  });

  const [isCehckListOpen, setIsCheckListOpen] = useState(false);
  const [selectedChecklistCategory, setSelectedChecklistCategory] =
    useState("");
  const [filterKey, setFilterKey] = useState(0);
  const [checklistSearch, setChecklistSearch] = useState("");
  const [allCheckListCategories, setAllCheckListCategories] = useState([]);

  const handlePageChange = (selectedItem) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: selectedItem.selected + 1,
    }));
  };

  const fetchAllCheckListCategories = async () => {
    try {
      const response = await apiUrl("/getAllCheckListCategory");
      if (response?.status === 200) {
        setAllCheckListCategories(response.data.data);
      } else {
        setAllCheckListCategories([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllCheckListCategories();
  }, []);

  const handlePerPageChange = (e) => {
    setPagination((prev) => ({
      ...prev,
      perPage: parseInt(e.target.value),
      currentPage: 1,
    }));
  };

  useEffect(() => {
    const perms = getPermissions();
    if (perms) setPermissions(perms);
  }, []);

  const getAllCheckListCategory = async () => {
    try {
      const response = await apiUrl.get("/getAllCheckListCategory");
      if (response?.status) {
        setCategories(response?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllCheckListCategory();
  }, []);
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchAllCheckLists();
    }, 500);
    return () => clearTimeout(delayDebounce);
  }, [pagination.currentPage, pagination.perPage, searchTerm, filterKey]);

  const handleEditorChange = (state) => {
    setEditorState(state);
    const html = convertToHTML(state.getCurrentContent());
    setChecklist((prev) => ({ ...prev, editor: html }));
  };

  const openAddModal = () => {
    setChecklist({ title: "", category: null, editor: "" });
    setEditorState(EditorState.createEmpty());
    setOpenModal(true);
    setEditMode(false);
  };

  const filteredChecklistCategories = React.useMemo(() => {
    if (!checklistSearch.trim()) return allCheckListCategories;
    return allCheckListCategories.filter((item) =>
      item.name.toLowerCase().includes(checklistSearch.toLowerCase())
    );
  }, [allCheckListCategories, checklistSearch]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".checklist-dropdown")) {
        setIsCheckListOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  // save checklist
  const saveChecklist = async (id) => {
    try {
      setLoading(true);
      const payload = {
        title: checklist.title,
        category: checklist.category.id,
        description: checklist.editor,
      };
      let response;
      if (editMode) {
        response = await apiUrl.put(`/checklistCategory/${id}`, payload);
      } else {
        response = await apiUrl.post("/checklistCategory", payload);
      }
      if (response?.status === 200) {
        setOpenModal(false);
        Swal.fire({
          title: "CheckList Created Successfully",
          icon: "success",
          timer: 3000,
          showConfirmButton: false,
          toast: true,
          position: "top-end",
        });
        fetchAllCheckLists();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAllCheckLists = async () => {
    try {
      setSkeleton(true);
      const params = {
        page: pagination?.currentPage,
        perPage: pagination?.perPage,
        checklist_category_id: selectedChecklistCategory || undefined,
      };
      if (searchTerm.trim()) {
        params.search = searchTerm.trim();
      }

      const response = await apiUrl.get("/getAllCheckLists", {
        params,
      });
      if (response?.status) {
        setPagination((prev) => ({
          ...prev,
          total: response?.data?.pagination?.total,
          lastPage: response?.data?.pagination?.lastPage,
          perPage: response?.data?.pagination?.perPage,
          currentPage: response?.data?.pagination?.currentPage,
        }));
        setData(response?.data?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setSkeleton(false);
    }
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await apiUrl.delete(`/deleteChecklist/${id}`);
          if (response?.data?.status) {
            Swal.fire({
              title: response.data.message,
              icon: "success",
              timer: 3000,
              toast: true,
              showConfirmButton: false,
              position: "top-end",
            });
            fetchAllCheckLists();
          }
        } catch (error) {
          Swal.fire({
            title: error.response?.data?.message || "Error deleting department",
            icon: "error",
            timer: 3000,
            toast: true,
            showConfirmButton: false,
            position: "top-end",
          });
        }
      }
    });
  };

  return (
    <>
      {permissions?.manage_checklist && (
        <div className="card px-4 py-3 bg-white">
          <header className="mb-3">
            <div className="flex align-center justify-between flex-wrap">
              <div className="flex align-center gap-3">
                <BackButton url="/checklist" />
              </div>

              <div>
                <Button
                  text="Add CheckList"
                  variant="primary"
                  size="md"
                  onClick={openAddModal}
                />
              </div>
            </div>
          </header>

          <div className="flex items-center justify-between mb-2">
            <h1 className="h4 font-semibold">Checklists </h1>
            <CustomSearch
              placeholder="Search checklist..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
              }}
              onClear={() => {
                setSearchTerm("");
              }}
            />
          </div>
          {/* filters */}
          <div className="mb-6 bg-gray-50 rounded-lg border border-gray-200 p-4 flex items-center">
            {/* Checklist Categories Dropdown */}
            <div className="col-3 min-w-[180px] relative checklist-dropdown fex gap-1">
              <div
                className="w-full text-sm py-2 px-3 border border-gray-300 rounded-md cursor-pointer bg-white focus-within:ring-1 focus-within:ring-blue-500"
                onClick={() => setIsCheckListOpen(!isCehckListOpen)}
              >
                <span className="truncate text-gray-800">
                  {selectedChecklistCategory
                    ? allCheckListCategories.find(
                        (c) => c.id == selectedChecklistCategory
                      )?.name || "— Select —"
                    : "— Select —"}
                </span>
              </div>

              {isCehckListOpen && (
                <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg">
                  <div className="p-2 border-b">
                    <input
                      type="text"
                      placeholder="Search categories..."
                      value={checklistSearch}
                      onChange={(e) => setChecklistSearch(e.target.value)}
                      className="w-full text-sm py-1 px-2 border rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none"
                      onClick={(e) => e.stopPropagation()}
                      autoFocus
                    />
                  </div>
                  <div
                    className="max-h-52 overflow-y-auto"
                    style={{ maxHeight: "400px" }}
                  >
                    {filteredChecklistCategories?.length === 0 ? (
                      <div className="px-3 py-2 text-gray-500 text-sm">
                        No checklist categories found
                      </div>
                    ) : (
                      filteredChecklistCategories?.map((cat) => (
                        <div
                          key={cat.id}
                          className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-sm text-gray-700 transition-colors"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedChecklistCategory(cat.id);
                            setIsCheckListOpen(false);
                            setChecklistSearch("");
                          }}
                        >
                          {cat.name}
                        </div>
                      ))
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className="flex items-center justify-end gap-2">
              <div>
                <Button
                  text="Clear"
                  variant="outline"
                  size="sm"
                  onClick={() => {
                    setFilterKey((prev) => prev + 1);
                    setSelectedChecklistCategory("");
                  }}
                />
              </div>
              <div>
                <Button
                  text="Apply Filter"
                  variant="primary"
                  size="sm"
                  onClick={() => {
                    setPagination((prev) => ({ ...prev, currentPage: 1 }));
                    setFilterKey((prev) => prev + 1);
                  }}
                />
              </div>
            </div>
          </div>
          {/* checklist table */}
          <table className="table w-full">
            <thead>
              <tr>
                <th>CheckList Title</th>
                <th>CheckList Category</th>
                <th>CheckList Description</th>
                <th>Created At</th>
                <th className="text-right">Actions</th>
              </tr>
            </thead>

            <tbody>
              {/* ---------- SKELETON (DaisyUI style) ---------- */}
              {skeleton ? (
                <>
                  {[...Array(3)].map((_, i) => (
                    <tr key={i}>
                      <td className="text-center py-3">
                        <span className="block h-5 w-16 bg-gray-300 rounded-md animate-pulse"></span>
                      </td>
                      <td className="text-center py-3">
                        <span className="block h-5 w-16 bg-gray-300 rounded-md animate-pulse"></span>
                      </td>
                      <td className="text-center py-3">
                        <span className="block h-5 w-16 bg-gray-300 rounded-md animate-pulse"></span>
                      </td>
                      <td className="text-center py-3">
                        <span className="block h-5 w-16 bg-gray-300 rounded-md animate-pulse"></span>
                      </td>
                      <td className="text-center py-3">
                        <span className="block h-5 w-16 bg-gray-300 rounded-md animate-pulse"></span>
                      </td>
                    </tr>
                  ))}
                </>
              ) : data?.length === 0 ? (
                <tr>
                  <td
                    colSpan={4}
                    className="text-center py-6 text-base-content/60"
                  >
                    No checklist found.
                  </td>
                </tr>
              ) : (
                /* ---------- REAL ROWS (your original logic) ---------- */
                data?.map((checklist) => (
                  <tr key={checklist.id}>
                    <td className=" align-middle">
                      <span className="flex items-center gap-2 text-sm text-base-content/70">
                        {checklist?.title || "—"}
                      </span>
                    </td>

                    <td className=" align-middle">
                      <span className="flex items-center gap-2 text-sm text-base-content/70">
                        {checklist?.category || "—"}
                      </span>
                    </td>
                    <td className="max-w-xs  align-middle">
                      <div
                        className="text-sm text-base-content/70 prose prose-xs max-w-none"
                        style={{ maxWidth: "24rem" }}
                        dangerouslySetInnerHTML={{
                          __html: checklist?.description || "—",
                        }}
                      />
                    </td>
                    <td className=" align-middle">
                      <span className="flex items-center gap-2 text-sm text-base-content/70">
                        <FaIcons.FaClock size={12} />
                        {new Date(checklist?.updated_at).toLocaleDateString()}
                      </span>
                    </td>

                    <td className=" align-middle">
                      <div className="flex justify-end gap-2">
                        <Button
                          text="Edit"
                          variant="primary"
                          size="sm"
                          isDisabled={loading}
                          onClick={() => {
                            const selectedCategory =
                              categories?.find(
                                (cat) => cat.name === checklist?.category
                              ) || null;

                            const html = checklist?.description || "";
                            let contentState;

                            if (html && html !== "<p></p>") {
                              const blocksFromHtml = htmlToDraft(html);
                              if (
                                blocksFromHtml &&
                                blocksFromHtml.contentBlocks
                              ) {
                                contentState =
                                  ContentState.createFromBlockArray(
                                    blocksFromHtml.contentBlocks,
                                    blocksFromHtml.entityMap
                                  );
                              }
                            }

                            const editorStateForEdit = contentState
                              ? EditorState.createWithContent(contentState)
                              : EditorState.createEmpty();

                            setChecklist({
                              id: checklist?.id,
                              title: checklist?.title,
                              category: selectedCategory,
                              editor: html,
                            });
                            setEditorState(editorStateForEdit);

                            setEditMode(true);
                            setOpenModal(true);
                          }}
                        />
                        <Button
                          text="Delete"
                          variant="danger"
                          size="sm"
                          onClick={() => handleDelete(checklist?.id)}
                          isDisabled={loading}
                        ></Button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          {/* Modal */}
          {openModal && (
            <>
              <div
                className="modal-backdrop fade show"
                style={{
                  display: "block",
                  backgroundColor: "rgba(0,0,0,0.45)",
                  zIndex: 1040,
                }}
                onClick={() => setOpenModal(false)}
              />

              <div
                className="modal fade show d-block h-full"
                tabIndex={-1}
                style={{ zIndex: 1050 }}
              >
                <div
                  className="modal-dialog modal-xl modal-dialog-centered h-full"
                  style={{ maxWidth: 800 }}
                >
                  <div className="modal-content border-0 rounded-4 shadow">
                    <div
                      className="modal-header"
                      style={{
                        background: "#f7f8fa",
                        borderBottom: "1px solid #eef2f6",
                      }}
                    >
                      <h5 className="modal-title fw-bold">
                        {editMode ? "Update CheckList" : "Add CheckList"}
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                      />
                    </div>

                    {/* Modal Body */}
                    <div className="modal-body">
                      <div className="d-flex flex-column gap-4">
                        {/* Title */}
                        <CustomInput
                          label="CheckList Title:"
                          placeholder="e.g., Travel History"
                          value={checklist.title}
                          onChange={(e) =>
                            setChecklist({
                              ...checklist,
                              title: e.target.value,
                            })
                          }
                        />

                        {/* Category Dropdown - HIGH Z-INDEX */}
                        <div style={{ position: "relative", zIndex: 1070 }}>
                          <SearchableDropdown
                            label="Category:"
                            options={categories}
                            value={checklist.category}
                            onChange={(selected) =>
                              setChecklist({ ...checklist, category: selected })
                            }
                            placeholder="Select a category..."
                          />
                        </div>

                        {/* Rich Text Editor - CONTROLLED HEIGHT */}
                        <div>
                          <label className="form-label fw-semibold mb-2">
                            Description:
                          </label>
                          <div
                            style={{
                              minHeight: "180px",
                              maxHeight: "280px",
                              overflowY: "auto",
                              border: "1px solid #ced4da",
                              borderRadius: "0.375rem",
                              backgroundColor: "#fff",
                            }}
                          >
                            <Editor
                              editorState={editorState}
                              onEditorStateChange={handleEditorChange}
                              placeholder="Enter checklist description..."
                              toolbar={{
                                options: [
                                  "inline",
                                  "blockType",
                                  "fontSize",
                                  "list",
                                  "textAlign",
                                  "link",
                                  "history",
                                ],
                                inline: { inDropdown: true },
                                list: { inDropdown: true },
                                textAlign: { inDropdown: true },
                                link: { inDropdown: true },
                                history: { inDropdown: true },
                              }}
                              wrapperStyle={{}}
                              editorStyle={{
                                minHeight: "120px",
                                padding: "0.5rem",
                              }}
                              toolbarStyle={{
                                backgroundColor: "#f8f9fa",
                                borderBottom: "1px solid #ced4da",
                                marginBottom: 0,
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Footer */}
                    <div
                      className="modal-footer d-flex justify-content-end align-items-center gap-2"
                      style={{
                        background: "#f7f8fa",
                        borderTop: "1px solid #eef2f6",
                      }}
                    >
                      <button
                        className="btn btn-outline-secondary"
                        onClick={() => setOpenModal(false)}
                        disabled={loading}
                      >
                        Cancel
                      </button>

                      <button
                        className="btn btn-success"
                        onClick={() => {
                          saveChecklist(checklist.id);
                        }}
                        disabled={
                          loading ||
                          !checklist.title ||
                          !checklist.category ||
                          checklist.editor === "<p></p>"
                        }
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" />
                            Saving...
                          </>
                        ) : (
                          <>{editMode ? "Update" : "Save"} CheckList</>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          <div className="row align-items-center mb-5 mt-2">
            <div className="col-auto">
              <select
                value={pagination?.perPage}
                onChange={handlePerPageChange}
                className="form-select"
                style={{ minWidth: 80 }}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
              </select>
            </div>
            <div className="col-auto text-muted">
              Page {pagination.currentPage} – Showing{" "}
              {Math.min(
                pagination.perPage,
                pagination.total -
                  (pagination.currentPage - 1) * pagination.perPage
              )}{" "}
              of {pagination.total} entries
            </div>
            <div className="col">
              <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                breakLabel={"..."}
                pageCount={pagination.lastPage}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={handlePageChange}
                forcePage={pagination.currentPage - 1}
                containerClassName={"pagination justify-content-end mb-0"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                activeClassName={"active"}
                disabledClassName={"disabled"}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AddCheckList;
